<template>
	<div v-loading="loadingPage" class="pageWrapper">
		<el-row>
			<el-col :span="24">
				<img class="logo" src="../assets/primaryLogo.svg" />
				<div class="noticeWrapper">
					<i style="color: green" v-if="verfied" class="el-icon-circle-check"></i>
					<i style="color: red" v-if="!verfied" class="el-icon-circle-close"></i>
					<h1 v-if="verfied">Email Successfully Verified</h1>
					<h1 v-if="!verfied">
						{{
							verificationFailureCode === 410
								? "Email Verification Link Expired"
								: "Unable To Verify Email"
						}}
					</h1>
					<el-alert
						v-if="verificationResent"
						:closable="false"
						style="margin-bottom: 12px"
						title="Email verification has been resent"
						description="Check your email for a verification link"
						type="success"
						show-icon
					>
					</el-alert>
					<el-alert
						v-if="verificationResentError"
						:closable="false"
						style="margin-bottom: 12px"
						title="There was an issue re-sending the verification email"
						description="Contact your system administrator"
						type="error"
						show-icon
					>
					</el-alert>
					<el-form
						v-if="!verfied && verificationFailureCode === 410"
						ref="form"
						@keyup.native.enter="resendVerification"
						:rules="formRules"
						label-position="top"
						label-width="100px"
						:model="resendVerificationForm"
					>
						<el-form-item prop="email" label="Email Signed Up With">
							<el-input
								type="email"
								placeholder="john.smith@acme.com"
								v-model="resendVerificationForm.email"
							></el-input>
						</el-form-item>
						<el-form-item>
							<el-button
								:loading="operationInProgress"
								:disabled="!emailIsValid || !resendVerificationForm.email"
								style="width: 100%; margin-top: 12px"
								@click="resendVerification"
								type="primary"
								>Resend Verification Email</el-button
							>
						</el-form-item>
					</el-form>
					<el-form v-if="verfied" ref="form">
						<el-form-item>
							<el-button @click="goTologin" style="width: 100%; margin-top: 12px" type="primary"
								>Go To Login
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { httpHelper } from "../utils/httpHelper.js";
let $this;
export default {
	data() {
		const validateEmail = function (rule, value, callback) {
			var re =
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(String(value).toLowerCase())) {
				callback(new Error("Please enter a valid email"));
				$this.emailIsValid = false;
			} else {
				callback();
				$this.emailIsValid = true;
			}
		};
		return {
			operationInProgress: false,
			loadingPage: true,
			emailIsValid: false,
			verfied: false,
			verificationFailureCode: null,
			verificationResent: false,
			verificationResentError: false,
			formRules: {
				email: [
					{ required: true, message: "An email is required", trigger: "change" },
					{ validator: validateEmail, trigger: "change" },
				],
			},
			resendVerificationForm: { email: "" },
		};
	},
	async beforeMount() {
		$this = this;
		await this.verify();
	},
	methods: {
		goTologin() {
			this.$router
				.push({
					name: "login",
					params: {
						emailVerified: true,
					},
				})
				.catch(() => {});
		},
		async resendVerification() {
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					this.operationInProgress = true;
					const result = await httpHelper(
						"RUNTIME",
						"POST",
						"security/resendVerificationEmail",
						this.resendVerificationForm
					);
					if (!result?.error) {
						this.resendVerificationForm.email = "";
						this.verificationResent = true;
						this.verificationResentError = false;
					} else {
						this.verificationResent = false;
						this.verificationResentError = true;
					}
					setTimeout(() => {
						this.operationInProgress = false;
					}, 500);
				} else {
					return;
				}
			});
		},
		async verify() {
			const token = this.$route?.params?.token;
			const userID = this.$route?.params?.userID;
			if (token && userID) {
				const result = await httpHelper("RUNTIME", "POST", "security/verifyEmail", {
					token: token,
					userID: userID,
				});
				if (!result?.error) {
					this.verfied = true;
				} else {
					this.verificationFailureCode = result.status;
					this.verfied = false;
				}
				setTimeout(() => {
					this.loadingPage = false;
				}, 1000);
			}
		},
	},
};
</script>

<style scoped>
.pageWrapper {
	height: 100vh;
	width: 100vw;
	text-align: left;
}

.logo {
	height: 40px;
	margin-left: 20px;
	margin-top: 20px;
}

.noticeWrapper {
	text-align: left;
	width: 400px;
	display: block;
	margin: auto;
	margin-top: 15%;
}

.noticeWrapper i {
	font-size: 40px;
	text-align: center !important;
}
</style>
